import { pagesDictionary } from '@/utils/dictionaries/pagesDictionary/pagesDictionary'

const routeParamToReplace = /\[[^\]]{1,200}]/
const routeRegexParam = '[^/]{1,200}'
const fallbackRoutes = Object.keys(pagesDictionary).map(
  (route) => new RegExp('^' + route.replace(routeParamToReplace, routeRegexParam) + '$')
)

export const isRouteValid = (path: string) => fallbackRoutes.some((route) => route.test(path))
